import {BundeslandFilterService} from '../../../../service/bundeslandFilter/bundesland-filter.service';
import {FirebaseService} from '../../../../service/firebase/firebase.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {BundesLandName} from '../../../../model/component/bundesland';
import {take} from 'rxjs/operators';
import {Component, Input, OnInit} from '@angular/core';
import {MesswertMeteogroupRbb} from '../../../../model/messwerte/messwert-meteogroup-rbb';
import {DatastoreService} from '../../../../service/datastore/datastore.service';
import {Astrowetter} from '../../../../model/messwerte/astrowetter';

@Component({
  selector: 'app-rbb-sonstiges-wetter',
  templateUrl: './rbb-sonstiges-wetter.component.html',
  styleUrls: ['./rbb-sonstiges-wetter.component.css']
})
export class RbbSonstigesWetterComponent implements OnInit {

  isLoading = false;
  @Input()
  selectedBundesland: string;
  selectedIndex = 0;
  rbbAstroWetter: Astrowetter = new Astrowetter();

  BERLIN = BundesLandName.BE;

  constructor(public bundeslandFilterService: BundeslandFilterService, private firebaseService: FirebaseService,
              private matSnackbar: MatSnackBar) {
    this.selectedBundesland = this.bundeslandFilterService.selectedBundesLand.name;
  }

  ngOnInit(): void {
    this.loadData();
  }

  private loadData() {
    this.isLoading = true;
    this.firebaseService.getAllMesswerteMeteoGroupRBB().pipe(take(1)).subscribe(data => {
      this.rbbAstroWetter = data.docs.find(d => d.id === 'Astrowetter').data();
    }, error => {
      console.log(error);
      this.matSnackbar.open('ERROR: Sonstiges Wetter ' + error, 'OK');
    }).add(() => this.isLoading = false);
  }
}
